<template>
	<div class="containerDebitDetail">
		<div class="row-options-buttons" v-if="!enviarProposta && !receberLigacao && !contatoDigital">
			<div>
				<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'" secondary-color="true" @click.native="enviarProposta = true" text="Envie sua proposta" />
			</div>
			<div>
				<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'" secondary-color="true" @click.native="receberLigacao = true" text="Receber uma ligação" />
			</div>
			<div>
				<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'" secondary-color="true" @click.native="contatoDigital = true" text="Receber contato digital para negociação" />
			</div>
		</div>
		<template v-if="enviarProposta">
			<SendProposal :divida="divida" @close="enviarProposta = false" />
		</template>
		<template v-else-if="receberLigacao">
			<ReceiveCall :divida="divida" @close="receberLigacao = false" />
		</template>
		<template v-else-if="contatoDigital">
			<DigitalContact :divida="divida" @close="contatoDigital = false" />
		</template>
		<template v-else>
			<template v-if="parcelaSelected === null">
				<div class="row-tabs">
					<div
						class="tab left"
						:style="typePayment === 'boleto' && parceiro ? { color: parceiroConfig.estilo.corPrimaria, borderColor: parceiroConfig.estilo.corPrimaria } : 'var(primaryColor)'"
						:class="{ active: typePayment === 'boleto' }"
						@click="typePayment = 'boleto'">Boleto</div>
					<div
						v-if="!parceiroConfig.sessoes.customization.campos.myDebits.flgSafrapay"
						class="tab right"
						:style="typePayment === 'cartao' && parceiro ? { color: parceiroConfig.estilo.corPrimaria, borderColor: parceiroConfig.estilo.corPrimaria } : 'var(primaryColor)'"
						:class="{ active: typePayment === 'cartao' }"
						@click="typePayment = 'cartao'">Cartão de Crédito</div>
					<div
						v-if="parceiroConfig.sessoes.customization.campos.myDebits.flgSafrapay && divida.loj_codigo != 171 && divida.loj_codigo != 187"
						class="tab"
						:style="typePayment === 'pix' && parceiro ? { color: parceiroConfig.estilo.corPrimaria, borderColor: parceiroConfig.estilo.corPrimaria } : 'var(primaryColor)'"
						:class="{ active: typePayment === 'pix' }"
						@click="typePayment = 'pix'">PIX</div>
					<div
						v-if="parceiroConfig.sessoes.customization.campos.myDebits.flgSafrapay && divida.loj_codigo != 171 && divida.loj_codigo != 187"
						class="tab right"
						:style="typePayment === 'link' && parceiro ? { color: parceiroConfig.estilo.corPrimaria, borderColor: parceiroConfig.estilo.corPrimaria } : 'var(primaryColor)'"
						:class="{ active: typePayment === 'link' }"
						@click="typePayment = 'link'">Link</div>
				</div>
				<div class="container-option-payment">
					<MonthlyPaymentCard :typePayment="typePayment" @click.native="parcelaSelected = parcela" v-for="parcela in changeFormasPagamento" :parcela="parcela" :key="parcela.codigo" :divida="divida" />
					<h6 class="message-empty" v-if="changeFormasPagamento.length === 0">
						{{ `Nenhuma opção de pagamento encontrada para a forma ${typePayment === "cartao" ? "cartão de crédito" : "boleto"}.` }}
					</h6>
				</div>
			</template>
			<DetailsMonthlyPayment v-else @backOption="parcelaSelected = null" :parcela="parcelaSelected" :divida="divida" :formaPagamento="typePayment"/>
		</template>
	</div>
</template>

<script>
import ButtonDefault from "@/components/buttons/ButtonDefault";
import globalMethods from "@/mixins/globalMethods";
import DetailsMonthlyPayment from "./DetailsMonthlyPayment";
import MonthlyPaymentCard from "./MonthlyPaymentCard";
import { mapActions, mapState } from "vuex";
import SendProposal from "./SendProposal";
import ReceiveCall from "./ReceiveCall";
import DigitalContact from "./DigitalContact";
export default {
	name: "PaymentOptionsDebit",
	components: {
		DigitalContact,
		ReceiveCall,
		SendProposal,
		MonthlyPaymentCard,
		DetailsMonthlyPayment,
		ButtonDefault
	},
	mixins: [globalMethods],
	props: ["divida", "formasPagamento"],
	data() {
		return {
			typePayment: "boleto",
			parcelaSelected: null,
			enviarProposta: false,
			receberLigacao: false,
			contatoDigital: false
		};
	},
	mounted() {
		this.action_salvar_etapa({
			pes_codigo: this.divida.pes_codigo,
			esn_fk_ets_codigo: 34,
			emp_codigo: this.parceiroConfig.emp_codigo,
			loj_codigo: this.divida.loj_codigo
		}).then((response) => {});
	},
	methods: {
		...mapActions(["action_salvar_etapa"])
	},
	watch: {
		parcelaSelected() {}
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig
		}),
		changeFormasPagamento() {
			return this.formasPagamento[this.typePayment];
		}
	}
};
</script>

<style scoped>
.containerDebitDetail {
	width: 100%;
	box-sizing: border-box;
	max-width: 750px;
	padding: 30px;
	background: var(--whiteColor);
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-bottom: 100px;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	margin-bottom: 30px;
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}

.row-buttons {
	display: flex;
	justify-content: center;
	align-items: center;
}

.container-option-payment {
	padding: 30px 0;
	max-height: 500px;
	overflow-y: auto;
}

.container-option-payment::-webkit-scrollbar {
	width: 5px;
	height: 0;
}

.container-option-payment::-webkit-scrollbar-thumb {
	background: #9a9a9a;
}

.row-tabs {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin: 0 0 0 0;
}

.tab {
	width: 100%;
	text-align: center;
	font-size: 16px;
	text-transform: uppercase;
	padding: 10px 0;
	border-bottom: 3px solid transparent;
	font-family: "Roboto Black";
	color: #9a9a9a;
}

.tab.active {
	border-bottom: 3px solid var(--primaryColor);
	font-family: "Roboto Black";
	color: var(--primaryColor);
}

.tab:hover {
	cursor: pointer;
}

.message-empty {
	text-align: center;
	padding: 40px 0;
	font-size: 14px;
	font-family: Roboto;
	color: #5b6987;
}

.row-options-buttons {
	display: flex;
	justify-content: center;
	align-items: center;
}

.row-options-buttons div {
	padding: 0 2px;
	margin-bottom: 30px;
}

@media only screen and (max-width: 600px) {
	.row-options-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.row-options-buttons div {
		padding: 0px;
		margin-bottom: 5px;
		width: 100%;
	}
}
</style>
